<template>
  <div class="table-container">
    <input-main
        v-if="isActiveSearch"
                :info-input="infoInput"
                @changeValue="value => $emit('search', value)"
                :value="search"/>
    <table class="custom-table">
      <thead>
      <tr>
        <th v-for="header in headers" :key="header.value">
          {{ header.text }}
        </th>
        <th class="actions-col"></th>
      </tr>
      </thead>

      <tbody>
      <template v-for="(item, index) in paginatedItems" :key="index">
        <!-- Основная строка -->
        <tr :class="[{'active': activeEditIndex === index}]">
          <td v-for="header in headers" :key="header.value" :class="header.class">
            {{ item[header.value] }}
          </td>
          <td>
            <div class="actions">
              <icon-default
                  v-if="activeEditIndex === index"
                  @click="toggleEditRow(index)" title="Отмена"
                  :color="'white'">
                <IconCross/>
              </icon-default>
              <icon-default
                  v-if="activeEditIndex !== index"
                  @click="toggleEditRow(index)" title="Редактировать"
                  :color="'dark-green'">
                <IconEdit/>
              </icon-default>
              <icon-default
                  v-if="activeEditIndex !== index"
                  @click="$emit('delete', item)" title="Удалить"
                  :color="'dark-green'">
                <IconDelete/>
              </icon-default>
            </div>
          </td>
        </tr>

        <!-- Раскрывающаяся строка -->
        <tr v-if="activeEditIndex === index" class="edit-row">
          <td :colspan="headers.length + 1">
            <div class="edit-content-invisible">
              <slot name="edit-row" :item="item"></slot>
            </div>
            <div class="edit-content-visible">
              <slot name="edit-row" :item="item"></slot>
            </div>
          </td>
        </tr>
      </template>

      <tr v-if="!paginatedItems.length">
        <td :colspan="headers.length + 1" class="no-data">Нет данных</td>
      </tr>
      </tbody>

    </table>

<!--    <div class="pagination" >-->

<!--      <button-->
<!--          v-for="page in visiblePages"-->
<!--          :key="page"-->
<!--          :class="{ active: page === currentPage }"-->
<!--          @click="setPage(page)"-->
<!--      >-->
<!--        {{ page }}-->
<!--      </button>-->

<!--    </div>-->
  </div>
</template>

<script>
import IconCross from "@/assets/icons/ui/cross.svg?inline"
import IconEdit from "@/assets/icons/ui/edit.svg?inline"
import IconDelete from "@/assets/icons/ui/delete.svg?inline"
import IconDefault from "@/components/shared/icons/IconDefault.vue"
import InputMain from "@/components/shared/input/InputMain.vue"

export default {
  name: 'TableView',

  components: {
    IconEdit,
    IconDelete,
    IconCross,
    IconDefault,
    InputMain
  },

  props: {
    headers: {
      type: Array,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    perPage: {
      type: Number,
      default: 100
    },
    isActiveSearch: {
      default: false,
    },
    search: {
      type: String
    },
    activeEditRow: {
      default: true,
    },
  },

  emits: ['edit', 'delete', 'page-change', 'search'],

  data() {
    return {
      currentPage: 1,
      activeEditIndex: null,
      infoInput: {
        placeholder: 'Введите запрос',
        typeInput: 'search',
        key: 'search'
      },
    }
  },

  computed: {
    totalPages() {
      return Math.ceil(this.items.length / this.perPage)
    },

    paginatedItems() {
      const start = (this.currentPage - 1) * this.perPage
      return this.items.slice(start, start + this.perPage)
    },

    visiblePages() {
      const pages = []
      const total = this.totalPages
      const current = this.currentPage

      if (total <= 5) return Array.from({ length: total }, (_, i) => i + 1)
      if (current <= 3) return [1, 2, 3, 4, '...', total]
      if (current >= total - 2)
        return [1, '...', total - 3, total - 2, total - 1, total]

      return [1, '...', current - 1, current, current + 1, '...', total]
    }
  },

  methods: {
    toggleEditRow(index) {
      this.$emit('edit', this.paginatedItems[index]);
      if (this.activeEditRow) {
        this.activeEditIndex = this.activeEditIndex === index ? null : index;
      }
    },
    setPage(page) {
      if (page === '...') return
      this.currentPage = page
      this.$emit('page-change', page)
    },

    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++
        this.$emit('page-change', this.currentPage)
      }
    },

    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--
        this.$emit('page-change', this.currentPage)
      }
    }
  },

  watch: {
    items() {
      this.currentPage = 1
    }
  }
}
</script>


<style scoped>
.table-container {
  width: 100%;
  border-radius: 8px;
}

.custom-table {
  width: 100%;
  border-collapse: collapse;
}

.custom-table thead {
  background-color: white;
  text-align: left;
  th{
    padding: 16px 20px;
    white-space: nowrap;
    font-weight: 500;
  }
}

.custom-table th,
.custom-table td {
  padding: 16px 23px;
  font-size: 14px;
  font-weight: 400;
  color: var(--color-dark-green);
  max-width: 300px;
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-word;
}

.custom-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 4px; /* ← отступ 4px между строками */
  tbody{
    tr{
      background: rgba(207, 215, 209, 0.2);
      transition: 0.3s;
      &.active{
        background: rgba(70, 132, 81, 1);
        td{
          color: white;
          font-weight: 500;

        }
        &:hover {
          background: rgba(70, 132, 81, 1);

        }
      }
    }
    tr:hover {
      transition: 0.3s;
      background: rgba(207, 215, 209, 0.4);
    }
    .edit-row{
      background: white !important;
      td{
        padding: 24px;
        position: relative;
        .edit-content-invisible{
          opacity: 0;
          position: unset !important;
          padding: 0 !important;
        }
        .edit-content-visible, .edit-content-invisible{
          border-left: 2px solid rgba(70, 132, 81, 1);
          border-right: 2px solid rgba(70, 132, 81, 1);
          border-bottom: 2px solid rgba(70, 132, 81, 1);
          border-bottom-left-radius: 10px;
          border-bottom-right-radius: 10px;
          position: absolute;
          left: 0;
          top: -12px;
          width: 100%;
          padding: 24px 24px 36px 24px;
          box-shadow: 0px 6px 16px 0px rgba(128, 143, 131, 0.25);

          &::v-deep{
            .edit-content{
              display: flex;
              flex-direction: column;
              row-gap: 32px;

              .title-slot-container{
                row-gap: 16px;
              }
              .big-title-container{
                font-size: 18px;
                color: var(--color-dark-green);
              }
            }
          }
        }
        &:hover{
          font-weight: normal;
        }
      }
    }
  }

  .actions {
    text-align: right;
    display: flex;
    justify-content: flex-end;
    gap: 16px;
    .icon-container{
      width: 32px !important;
      height: 32px !important;
      cursor: pointer;
      justify-content: center;
      align-items: center;
      border-radius: 8px;

      svg {
        width: 20px;
        height: 20px;
      }
      &:hover{
        background: rgba(207, 215, 209, 0.4);

      }
    }
  }
}


.no-data {
  text-align: center;
  color: #777;
  padding: 20px;
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
  padding: 14px 0;
}

.pagination button {
  border: none;
  background: #e6efe6;
  padding: 6px 12px;
  border-radius: 10px;
  cursor: pointer;
  font-size: 14px;
}

.pagination button.active {
  background: #355e3b;
  color: white;
  font-weight: 400;
}

.pagination button:disabled {
  background: #f0f0f0;
  cursor: not-allowed;
  opacity: 0.6;
}

td:first-child {
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}

td:last-child {
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}
.td-tags{
  max-width: 250px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.td-description{
  max-width: 400px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
